import React, { Component } from 'react';
import Label from '../../../../components/atoms/Label';
import DataTable from '../../DataTable';
import dateFormatIndo from '../../../../utils/helpers/dateFormatIndo';
import ReactDOM from 'react-dom';
import Button from '../../../../components/atoms/Button';

class RiwayatStatus extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      coloumnDataTable : [
        { data: "loanProgress",	 title: "Status" },
				{ data: "userTypeName",	 title: "Tipe Pengguna" },
        { data: "createdAt",	 title: "Waktu" },
      ],
      coloumnDefs : [
				{
					targets: [0, 1],
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span>{cellData || '-'}</span>, td );
					}
        },
        {
          targets: 2,
					createdCell: (td, cellData, rowData, row, col) => { 
            ReactDOM.render( <span>{cellData ? dateFormatIndo(cellData, 'long', ' ', 'hms') : '-'}</span>, td );
					}
        }
      ]
    };
  }
  componentDidMount = () =>{
  }
  render() {
    let { title, statusHistory } = this.props
    let { data, coloumnDataTable } = this.state
    console.log('====================================');
    console.log({ statusHistory });
    console.log('====================================');
    return (
      <div>
        <Label value={title} className='label-menu'/>
        <DataTable
          data = {statusHistory} 
          coloumn = {coloumnDataTable} 
          // handleDetail = {this.handleDetail} 
          coloumnDefs = {this.state.coloumnDefs}
        />

      </div>
    );
  }
}

export default RiwayatStatus;